<template>
    <exportTemplate ref="exportTemplate" :formModel="formModel" :table-data="tableList" :summary-data="tableSummaryData" :table-total="paginationTotal" :table-load="tableLoading" @set-custom-columns="setCustomColumns" @close-custom-columns="closeCustomColumns" @pagination-change="paginationChange" @form-submit="formSubmit" @form-reset="formReset" @sort="sortChange" @table-export="tableExport">
        <template #form>
            <el-form-item label="日期范围" prop="billDate.selected">
                <date-picker style="width: 100%;" v-model="formModel.billDate.selected" type="daterange" align="right"
                    unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    value-format="yyyy-MM-dd" :picker-options="pickerOptions"></date-picker>
            </el-form-item>
            <el-form-item label="库房" prop="warehouse.selected">
                <select-multiple :select-data="formModel.warehouse"></select-multiple>
            </el-form-item>
            <el-form-item label="商品" prop="product.selected">
                <el-select class="select_multiple" style="width: 100%;" ref="productSelectRef"
                    v-model="formModel.product.selected" value-key="value" multiple clearable placeholder="请选择商品名称"
                    @focus="productInputFocus" @change="productChange">
                    <el-option v-for="item in formModel.product.list" :key="item.value" :label="item.text"
                        :value="item"></el-option>
                </el-select>
            </el-form-item>
        </template>
        <template>
            <el-table-column label="库房" prop="warehouseName" width="140" sortable="custom" fixed>
                <template slot-scope="scope">
                    <span>{{ scope.row.warehouseName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="员工" prop="salesmanName" width="140" fixed></el-table-column>
            <el-table-column label="商品" prop="itemName" sortable="custom" width="200" fixed>
                <template slot-scope="scope">
                    <span>{{ scope.row.itemName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="规格" prop="itemSpec" width="120" v-if="customColumnList['itemSpec']"></el-table-column>
            <el-table-column label="条码" prop="barcodeStr" width="180" v-if="customColumnList['barcodeStr']"></el-table-column>
            <el-table-column label="销售数量" prop="billQtyStr" width="140" sortable="custom" v-if="customColumnList['billQtyStr']"></el-table-column>
            <el-table-column label="销售小单位数量" prop="billQty" width="150" sortable="custom" v-if="customColumnList['billQty']"></el-table-column>
            <el-table-column label="销售均价（大）" prop="salAvgBillPrice" width="140" sortable="custom" v-if="customColumnList['salAvgBillPrice']"></el-table-column>
            <el-table-column label="销售均价（小）" prop="invAvgBillPrice" width="140" sortable="custom" v-if="customColumnList['invAvgBillPrice']"></el-table-column>
            <el-table-column label="销售总额" prop="totalAmt" width="120" v-if="customColumnList['totalAmt']"></el-table-column>
            <el-table-column label="退货数量" prop="retBillQryStr" width="120" sortable="custom" v-if="customColumnList['retBillQryStr']"></el-table-column>
            <el-table-column label="退货小单位数量" prop="retBillQry" width="140" sortable="custom" v-if="customColumnList['retBillQry']"></el-table-column>
            <el-table-column label="退货均价（大）" prop="salAvgRetPrice" width="120" v-if="customColumnList['salAvgRetPrice']"></el-table-column>
            <el-table-column label="退货均价（小）" prop="invAvgRetPrice" width="120" v-if="customColumnList['invAvgRetPrice']"></el-table-column>
            <el-table-column label="退货总额" prop="retTotalAmt" width="120" v-if="customColumnList['retTotalAmt']"></el-table-column>
            <el-table-column label="净销售数量" prop="cleanQryStr" width="120" sortable="c ustom" v-if="customColumnList['cleanQryStr']"></el-table-column>
            <el-table-column label="净销售小单位数量" prop="cleanQry" width="150" sortable="custom" v-if="customColumnList['totalAmt']"></el-table-column>
            <el-table-column label="净金额总额" prop="cleanTotalAmt" width="120" sortable="custom" v-if="customColumnList['cleanTotalAmt']"></el-table-column>
            <el-table-column label="承包价" prop="salContractPrice" width="140" v-if="customColumnList['salContractPrice']"></el-table-column>
            <el-table-column label="承包价小单位价格" prop="invContractPrice" width="150" sortable="custom" v-if="customColumnList['invContractPrice']"></el-table-column>
            <el-table-column label="承包总额" prop="contractPriceTotalAmt" width="140" sortable="custom" v-if="customColumnList['contractPriceTotalAmt']"></el-table-column>
            <el-table-column label="毛利" prop="profit" width="140" sortable="custom" v-if="customColumnList['profit']"></el-table-column>
            <el-table-column label="毛利率" prop="profitMarginStr" width="140" sortable="custom" v-if="customColumnList['profitMarginStr']"></el-table-column>
        </template>
        <el-dialog title="选择商品" :visible.sync="selectProductVisible" width="1080px" append-to-body
            :close-on-click-modal="false" custom-class="product-dialog">
            <selectProduct v-if="selectProductVisible" @get-product-data="getProductData"
                :default-checked-keys="formModel.product.list"></selectProduct>
        </el-dialog>
    </exportTemplate>
</template>

<script>
import exportTemplate from '@/components/common/exportTemplate.vue'
import datePicker from '@/components/common/datePicker.vue'
import selectProduct from '@/components/common/selectProduct.vue'
import { pickerOptions, getNowFormatDate, getAddDate, getQueryItem, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
    name: 'mainAccount',
    components: {
        exportTemplate,
        datePicker,
        selectProduct
    },
    data() {
        return {
            pickerOptions,
            params: {
                page: 1,
                size: 10,
                beginDate: getAddDate(-3),
                endDate: getNowFormatDate()
            },
            formModel: {
                billDate: { submitName: 'billDate', selected: [getAddDate(-3), getNowFormatDate()] },
                warehouse: { submitName: 'warehouseID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll:false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择库房', request: { url: '/Account/wareHouseDefine/selectWarehouseForVue.html', type: 'post', params: {page: 1, size: 5, isHeteroValence: 'Y'}, text: '', value: '' }},
                product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
            },
            paginationTotal: 0,
            tableList: [],
            tableLoading: false,
            tableSummaryData: {},
            dialogCustomerVisible: false,
            customColumnsList: [
                {
                    "label": "规格",
                    "prop": "itemSpec",
                },
                {
                    "label": "条码",
                    "prop": "barcodeStr",
                },
                {
                    "label": "销售数量",
                    "prop": "billQtyStr",
                },
                {
                    "label": "销售小单位数量",
                    "prop": "billQty",
                },
                {
                    "label": "销售均价（大）",
                    "prop": "salAvgBillPrice",
                },
                {
                    "label": "销售均价（小）",
                    "prop": "invAvgBillPrice",
                },
                {
                    "label": "销售总额",
                    "prop": "totalAmt",
                },
                {
                    "label": "退货数量",
                    "prop": "retBillQryStr",
                },
                {
                    "label": "退货小单位数量",
                    "prop": "retBillQry",
                },
                {
                    "label": "退货均价（大）",
                    "prop": "salAvgRetPrice",
                },
                {
                    "label": "退货均价（小）",
                    "prop": "invAvgRetPrice",
                },
                {
                    "label": "退货总额",
                    "prop": "retTotalAmt",
                },
                {
                    "label": "净销售数量",
                    "prop": "cleanQryStr",
                },
                {
                    "label": "净销售小单位数量",
                    "prop": "cleanQry",
                },
                {
                    "label": "净金额总额",
                    "prop": "cleanTotalAmt",
                },
                {
                    "label": "承包价",
                    "prop": "salContractPrice",
                },
                {
                    "label": "承包价小单位价格",
                    "prop": "invContractPrice",
                },
                {
                    "label": "承包总额",
                    "prop": "contractPriceTotalAmt",
                },
                {
                    "label": "毛利",
                    "prop": "profit",
                },
                {
                    "label": "毛利率",
                    "prop": "profitMarginStr",
                }
            ],
            customColumn: [],
            selectProductVisible: false
        }
    },
    created() {
        this.getCustomColumnsList()
        this.getTableList()
    },
    computed: {
        customColumnList() {
            let tempItem = {}
            this.customColumn.forEach(i => {
                tempItem[i.prop] = (i.isShow == 'Y')
            })
            return tempItem
        }
    },
    methods: {
        setCustomColumns(el) {
            let tempArr = [...this.customColumn]
            el.loading = false
            el.setCustomcolumns(tempArr)
        },
        closeCustomColumns(el) {
            el.$nextTick(async () => {
                let { customColumns } = el
                const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
                    funcCode: 240,
                    customSetInfo: JSON.stringify(customColumns)
                }))

                if (res.code != 'success') return this.$message.error(res.message)
                this.$message.success(res.message)
            })
        },
        productChange(val) {
            this.formModel.product.list = val
        },
        async getCustomColumnsList() {
            const { data: res } = await this.$http.post(
                "Account/dataSearchVue/selectColumnByFuncCode.html",
                this.Qs.stringify({ funcCode: 240 })
            );
            if (res.code != "success") return this.$confirm(res.message, "提示", {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "error",
            });
            let result = JSON.parse(res.result);
            let arr = [];
            this.customColumnsList.forEach((item) => {
                result.forEach(($item) => {
                    if (item.prop == $item.prop) {
                        arr.push({
                            id: $item.id,
                            label: item.label,
                            prop: item.prop,
                            isShow: $item.isShow,
                        });
                    }
                });
            });
            this.customColumn = [...arr]
        },
        paginationChange({page, size, isGetTable = true}) {
            this.params.page = page
            this.params.size = size
            if (isGetTable) {
                this.getTableList()
            }
        },
        formSubmit() {
            this.params = { ...this.params, ...getQueryItem(this.formModel) }
            this.getTableList()
        },
        formReset() {
            this.params['sortField'] = ''
            this.params['softBy'] = ''
            this.params.page = 1
        },
        async getTableList() {
            this.tableLoading = true
            this.tableData = []
            const { data: res } = await this.$post(
                "/erpnew/account/c/reada46ceb/contract/contractWorkPriceSelect.html",
                this.params
            )
            this.tableLoading = false
            if (res.code != '0') return this.$message.error(res.message)
            if(res.data != null) {
                let { list, sum, totalSum } = res.data
                this.paginationTotal = totalSum
                this.tableSummaryData = sum
                this.tableList = list
            }else {
                this.paginationTotal = 0
                this.tableSummaryData = {}
                this.tableList = []
            }
        },
        sortChange({ sortField, sortBy }) {
            this.params['sortBy'] = sortBy
            if(sortField == 'warehouseName'){
                sortField = 'warehouseID'
            }else if(sortField == 'itemName'){
                sortField = 'itemID'
            }else if(sortField == 'billQtyStr'){
                sortField = 'billQty'
            }else if(sortField == 'retBillQryStr'){
                sortField = 'retBillQry'
            }else if(sortField == 'cleanQryStr'){
                sortField = 'cleanQry'
            }else if(sortField == 'profitMarginStr'){
                sortField = 'profitMargin'
            }
            this.params['sortField'] = sortField
            this.params.page = 1
            this.getTableList()
        },
        tableExport(tabColumn) {
            // console.log(tabColumn)
            exportExcelCommonForVue(this.params, tabColumn, '/erpnew/account/c/reada46ceb/contract/contractWorkExcelReport.html')
        },
        productInputFocus() {
            this.$refs['productSelectRef'].blur()
            this.selectProductVisible = true
        },
        getProductData(data) {
            this.selectProductVisible = false
            this.formModel.product.selected = data
            this.formModel.product.list = data
        },
    }
}


</script>

<style lang="less" scope>
::v-deep .el-dialog__header {
    padding-left: 20px;
}
</style>